<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.exame"
                    :request-query-string-params="{ not_id: null }"
                    :search-fields="fields.grupoExame"
                    :validations="validations.grupoExame"
                    label="Grupo de exame / Exame"
                    :text-field="i => i.codigo ? `${this.formatProcedimento(i.codigo)} - ${i.nome}` : i.nome"
                    uppercase
                    v-model="model.grupoExame"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                     v-model="model.exigeDocumentoAnexo"
                     :label="false"
                >
                    Exige documento anexo
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    {{ exame ? 'Atualizar' : 'Incluir' }}
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                grupoExame: { required: true },
            }
        },
        examesReguladosIds() {

            return this.regulador.exames.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            grupoExame: [
                { key: 'item.codigo', searchable: true },
                { key: 'item.nome', searchable: true },
            ],
        },
        model: {
            grupoExame: null,
            exigeDocumentoAnexo: false,
            isUpdate: false
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.model.isUpdate) {

                const index = this.regulador.exames.findIndex(e => e.id === this.model.grupoExame.id)

                if (index !== -1) {

                    const updatedExame = {
                        ...this.regulador.exames[index],
                        exigeDocumentoAnexo: this.model.exigeDocumentoAnexo
                    }

                    this.$emit('exameUpdate', updatedExame)
                    this.regulador.exames.splice(index, 1, updatedExame)
                }

                this.model.isUpdate = false
                this.model.grupoExame = null
                this.model.exigeDocumentoAnexo = false

                this.resetForm()
            } else {

                if (this.model.grupoExame.origem === 'exame') {

                    if(this.examesReguladosIds.includes(this.model.grupoExame.id)) {
                        this.showAlert('Exame ou grupo já existente.', 'Atenção')
                        this.resetForm()
                        return
                    }

                    this.regulador.exames.push(this.prepareData(this.model.grupoExame))
                    this.model.exigeDocumentoAnexo = false

                    this.resetForm()
                } else {

                    this.getExames().then(exames => {
                        exames.forEach((exame) => {
                            if(this.examesReguladosIds.includes(exame.id)) {
                                this.showAlert('Exame ou grupo já existente.', 'Atenção')
                                this.resetForm()
                                return
                            }

                            this.regulador.exames.push(this.prepareData(exame))
                        })

                        this.model.exigeDocumentoAnexo = false
                        this.resetForm()
                    })
                }
            }
        },
        async getExames() {

            let exames = [];

            this.setLoading()

            try {

                exames = (await this.repositories.parametrizacao.list({
                    listar: 'exames',
                    grupo_id: this.model.grupoExame.id
                })).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return exames
        },
        prepareData(exame) {

            exame = this.clone(exame)
            exame.ativo = true
            exame.exigeDocumentoAnexo = this.model.exigeDocumentoAnexo

            return exame

        },
        resetForm() {

            this.model.grupoExame = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, error, object, formats],
    props: {
        regulador: { type: Object, required: true },
        exame: { type: Object, default: null },
    },
    watch: {
        exame: {
            handler(newValue) {

                if (newValue) {

                    this.model.isUpdate = true
                    this.model.grupoExame = this.clone(newValue)
                    this.model.exigeDocumentoAnexo = newValue.exigeDocumentoAnexo
                } else {
                    
                    this.model.isUpdate = false
                    this.model.grupoExame = null
                    this.model.exigeDocumentoAnexo = false
                }
            },
            immediate: true
        }
    }
}
</script>